import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Configuracion from './Configuracion';
import getProductInfo from '../../services/productInfo';
import { addResumenData, setIdResumen } from '../../globalslice';
import loadingIcon from '../../images/loading.png';

const EmailMktWrapper = ({ idproduct }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const currency = useSelector(state => state.global.currency);
  const tokenRef = useSelector(state => state.global.tokenRef);
  const slug = useSelector(state => state.global.slug);
  const idResumen = useSelector(state => state.global.idResumen);
  const period = searchParams.has('billingcycle') ? searchParams.get('billingcycle') : 'annually';
  const [loading, setLoading] = useState(true);
  const initialized = useRef(new Set()); // Usamos un Set para evitar repeticiones

  const allowedProducts = [229, 230, 231, 232, 233]; //Productos de email marketing gid=5

  useEffect(() => {
    if (allowedProducts.includes(Number(idproduct)) && !initialized.current.has(idproduct)) {
      initialized.current.add(idproduct); // Marcar este idproduct como procesado
      fetchProductInfo();
    } else {
      setLoading(false);
    }
  }, [idproduct]);

  const fetchProductInfo = async () => {
    try {
      const clientData = await getProductInfo({ idproduct, currency, tokenRef, slug });
      
      if (clientData.success === 'success') {
        const periodMapping = {
          "monthly": "1 mes",
          "quarterly": "3 meses",
          "semiannually": "6 meses",
          "annually": "12 meses",
          "biennially": "24 meses",
          "triennially": "36 meses"
        };

        const periodoBuscado = periodMapping[period];
        const periodoSeleccionado = clientData.data.findIndex(item => item.Periodo === periodoBuscado);
        
        const crosss_price = clientData.data[periodoSeleccionado].DescuentoMostrar 
          ? false 
          : clientData.data[periodoSeleccionado].Promo;

        const selectPeriods = clientData.data.reduce((acc, period) => {
          const cross = period.DescuentoMostrar ? false : (period.Descuento !== period.Precio && period.Descuento !== 0);
          acc[period.Periodo] = {
            cost: period.Descuento,
            cross_price: cross,
            second_price: period.Precio
          };
          return acc;
        }, {});
        let idResumenLocal = idResumen + 1;

        dispatch(addResumenData({
          product: {
            name: clientData.name,
            smallname: clientData.smallname,
            description: clientData.description,
            domain_section: [{ dominio_principal: null }],
            id: idproduct
          },
          price: {
            cost: clientData.data[periodoSeleccionado].Descuento,
            second_price: clientData.data[periodoSeleccionado].Precio,
            cross_price: crosss_price
          },
          periodo: clientData.data[periodoSeleccionado].Periodo,
          id: idResumenLocal,
          actual: false, //seteamos a false porque no necesita de configuración
          type: clientData.type,
          selectPeriods: selectPeriods,
          isOX: clientData.is_ox,
          isWP: clientData.is_wp,
          sos: []
        }));

        dispatch(setIdResumen(idResumenLocal));
        navigate('/checkout'); 
      }
    } catch (error) {
      console.error('Error al obtener info del producto:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className='bsq-load'>
        <img src={loadingIcon} alt="Cargando..." className="bsq-load-icon" />
      </div>
    );
  }

  return <Configuracion />;
};

export default EmailMktWrapper;
